export default "__VITE_ASSET__CKi$sSM7__"